import { GridSortItem } from "@mui/x-data-grid";

export const SortByName: GridSortItem = {field: 'name', sort: 'asc'}